import React from 'react';
import { Router, Route } from 'react-router';

import PageContent from './modules/PageContentLoader';
import BrokBackgroundImg from 'modules/BrokBackgroundImg';
import Popup from 'modules/Popup';

import { connect } from 'react-redux';
import createHistory from "history/createBrowserHistory"
import Menu from './modules/Menu';

const history = createHistory();

// Get the current location.
const location = history.location;

// Listen for changes to the current location.
const unlisten = history.listen((location, action) => {
	// location is an object like window.location
	console.log(action, location.pathname, location.state)
});

export default connect(state => ({
	menu: state.menu.concat(state.menuQuick)
}))(class extends React.Component { 

	state = {}

	handleContextRef = contextRef => this.setState({ contextRef })

	render() {
		const {menu} = this.props; 
		return (
			<Router history={history} >
				<div className="App" ref={this.handleContextRef}>
					<Popup/>
					<BrokBackgroundImg/>
					<Menu>
						<PageContent menu={menu} contextRef={this.state.contextRef} />
					</Menu>
					<Route path="/" render={({location}) => {
						if (typeof window.ga === 'function') {
							window.ga('gtag_UA_105803300_1.set', 'page', location.pathname + location.search);
							window.ga('gtag_UA_105803300_1.send', 'pageview');
						}
						if (typeof window.scroll === 'function') {
							try {
								window.scroll({
									top: 0,
									left: 0,
									behavior: 'smooth'
								});
							} catch (e) {
								console.error(e);
							}
						} else {
							document.body.scrollTop = document.documentElement.scrollTop = 0;
						}
						return null;
					}} />
				</div>
			</Router>
		);
	}
});



// WEBPACK FOOTER //
// ./src/App.js